import { useState } from 'react';
import ReactCountryFlag from "react-country-flag";
import ChatIcon from '../../../assets/Profile/ChatIcon';
import CrownIcon from '../../../assets/Profile/CrownIcon';
import DiscordLink from '../../../assets/Profile/DiscordLink';
import FacebookIcon from '../../../assets/Profile/FacebookIcon';
import GithubIcon from '../../../assets/Profile/GithubIcon';
import TikTokIcon from '../../../assets/Profile/TitTokIcon';
import VerifiedIcon from '../../../assets/Profile/VerifiedIcon';
import XIcon from '../../../assets/Profile/XIcon';
import YoutubeIcon from '../../../assets/Profile/YoutubeIcon';
import { useAuth } from '../../../contexts/auth';
import EditProfileModal from '../../Modals/EditProfileModal';
import PixelButton from '../../PixelButton';

import Instagram from '../../../assets/Profile/Instagram';
import TelegramIcon from '../../../assets/Profile/TelegramIcon';
import Twitch from '../../../assets/Profile/Twitch';
import WhatsAppIcon from '../../../assets/Profile/WhatsApp';
import { useMessages } from '../../../contexts/messages';
import { api } from '../../../services/api';
import { numberFormatter } from '../../../utils/formatter';
import {
  Avatar,
  ButtonsContainer,
  Container,
  DisplayName,
  Info,
  JobDescription,
  LinksContainer,
  LinksTitle,
  NameContainer,
  NamesContainer,
  Numbers,
  NumbersContainer,
  SobreContainer,
  SobreText,
  SobreTitle,
  TopContainer,
  UserName
} from './styles';

type ProfileProps = {
  userId: string;
  avatar: any;
  username: string;
  followers: number;
  following: number;
  description: string;
  links: string[];
}

export default function Profile({ userId, avatar, username, followers, following, description, links }: ProfileProps) {
  const { user } = useAuth();
  const { createChat } = useMessages();
  const [editModal, setEditModal] = useState<boolean>();

  const handleFollow = async () => {
    try {
      api.post(`/follow/${userId}`).then(response => {

      }, error => {
        console.error(error);
      }
      );
    } catch (error) {
      console.error(error);
    }
  }

  const handleChat = async () => {
    createChat(username, [userId]);
  }

  return (
    <Container>
      <TopContainer>
        <Avatar src={avatar} alt="Avatar" />
        <NamesContainer>
          <NameContainer>
            <DisplayName>{username ? username : 'N/A'}</DisplayName>
            <VerifiedIcon />
          </NameContainer>
          <JobDescription>Game Designer / Ilustrador</JobDescription>
          <NameContainer style={{ alignItems: 'flex-end' }} >
            <UserName>@{username ? username : 'N/A'}</UserName>
            <ReactCountryFlag countryCode="BR" svg style={{ width: '21px' }} />
          </NameContainer>
        </NamesContainer>
      </TopContainer>
      <div style={{ gap: 8, display: 'flex', flexDirection: 'column' }} >
        <NumbersContainer>
          <Numbers>{numberFormatter(followers)}</Numbers>
          <Info>Seguidores</Info>
          <Numbers>{numberFormatter(following)}</Numbers>
          <Info>Seguindo</Info>
        </NumbersContainer>
        <ButtonsContainer>
          <CrownIcon />
          {user && user.username !== username ? <div onClick={handleChat} style={{ cursor: 'pointer' }}><ChatIcon /></div> : <></>}
          {user && user.username !== username ?
            <PixelButton innerWidth={140} color="#6E30E9" label="Seguir" onClick={() => handleFollow()} />
            :
            <PixelButton color="#6E30E9" label="Editar" onClick={() => setEditModal(true)} />
          }
          {editModal && <EditProfileModal open={editModal} onClose={setEditModal} />}
        </ButtonsContainer>
      </div>
      <SobreContainer>
        <SobreTitle>Sobre</SobreTitle>
        <SobreText>{description}</SobreText>
      </SobreContainer>
      <LinksTitle>Links</LinksTitle>
      <LinksContainer>
        <DiscordLink />
        <FacebookIcon />
        <Instagram />
        <GithubIcon />
        <TelegramIcon />
        <TikTokIcon />
        <Twitch />
        <WhatsAppIcon />
        <XIcon />
        <YoutubeIcon />
      </LinksContainer>
    </Container>
  )
}